import React from 'react';
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import AllProducts from "../../components/Shop/AllProducts";

const ShopAllProducts = () => {
  return (
    <div className="shop-all-products-page-container">
        <DashboardHeader />
        <div className="shop-all-products-page-content shop-management-layout">
            <div className="shop-all-products-page-sidebar shop-management-sidebar-slot">
              <DashboardSideBar active={7} />
            </div>
            <main className="shop-all-products-page-main shop-management-main-panel">
                <AllProducts />
            </main>
        </div>
    </div>
  );
};

export default ShopAllProducts;
